
import React, { useMemo } from 'react'
import queryString from 'query-string'

import { useLocation } from 'react-router'
import { HeroCard } from '../heroes/HeroCard'
import { useForm } from '../hooks/useForm'



import './estilos.css'
import { getHeroByIdName } from '../../selectors/getHeroByIdName'

export const Search = ({ history }) => {

    const locationt = useLocation();
    const { q = '' } = queryString.parse(locationt.search)
    console.log(q)
    // console.log(locationt.search)
    //useLocation => tine varias propiedades utiles
    //si no busco nada el la propiedad => search va estar vacio
    //search tiene la ruta 

    const [formValues, handleInputChange] = useForm({
        search_superHero: q,
    })

    const { search_superHero } = formValues

    const heroesFilter = useMemo(() => getHeroByIdName(q), [q])


    const handleSearch = (e) => {
        e.preventDefault()
        history.push(`?q=${search_superHero}`)
    }


    return (
        <div>

            <h1>Search</h1>
            <hr></hr>

            <div className='row'>

                <div className='col-5'>
                    <h4>Tus Heroes Favoritos</h4>
                    <hr />

                    <form onSubmit={handleSearch}>

                        <label><i className="fas fa-search"></i></label>

                        <input type='text'
                            placeholder='Buscar Heroe'
                            className='form-control'
                            value={search_superHero}
                            onChange={handleInputChange}
                            name='search_superHero'
                        />

                        <button
                            type='submit'
                            className='btn m-1 btn-block btn-outline-primary'
                        >
                            Buscar
                        </button>
                    </form>

                </div>


                <div className='col-7'>
                    <h4>Results</h4>


                    {
                        (q === '')//si la q esta vacia retorna esta clase
                        &&
                        <div className="alert alert-info"> Seach Hero</div>
                    }


                    {
                        (q !== '' && heroesFilter.length === 0)//si q es diferente a un string vacio y si es es igual cero
                        &&
                        < div className="alert alert-danger">No existe el heroe {q}</div>
                    }



                    {
                        heroesFilter.map(hero => (
                            <HeroCard
                                key={hero.id}
                                {...hero}
                            />
                        ))
                    }
                </div>


            </div>

        </div >


    )
}
